import { RouteProps, routes, localStorageKeys } from '@sketch/constants'
import PrivateRoute from 'containers/PrivateRoute'
import React, { useState } from 'react'
import { Switch } from 'react-router-dom'
import { getItem } from '@sketch/utils'

import { PrivateWorkspaceRoute } from '../PrivateWorkspaceRoute'
import { RestrictedWorkspaceBannerManager } from './RestrictedWorkspaceBannerManager'

const UpdatesGuard = () => {
  const [workspaceId] = useState<string | undefined>(
    getItem(localStorageKeys.lastWorkspaceIdKey)
  )

  if (!workspaceId) return null

  return <RestrictedWorkspaceBannerManager workspaceId={workspaceId} />
}

const WorkspaceGuard = (props: RouteProps<'WORKSPACE'>) => {
  const {
    match: {
      params: { workspaceId },
    },
  } = props
  return <RestrictedWorkspaceBannerManager workspaceId={workspaceId} />
}

export const RestrictedWorkspaceBannerManagerSwitch = () => {
  return (
    <Switch>
      <PrivateWorkspaceRoute
        path={[
          routes.WORKSPACE_SETTINGS.template(),
          routes.WORKSPACE_DISCOVER.template(),
          routes.WORKSPACE_SUBSCRIBE.template(),
          routes.WORKSPACE_PROJECT.template(),
          routes.WORKSPACE_SHARES.template(),
          routes.WORKSPACE_LIBRARIES.template(),
          routes.WORKSPACE_TRASH.template(),
          routes.WORKSPACE_DRAFTS.template(),
          routes.WORKSPACE_SHARED_WITH_ME.template(),
          routes.WORKSPACE_TEMPLATES.template(),
          routes.WORKSPACE_TRASH_PROJECT.template(),
        ]}
        component={WorkspaceGuard}
        skipErrorView
      />

      {/**
       * This isn't ideal, right now `Updates` view in essence depends on the workspace, but due to historical reasons
       * it also at the same time "doesn't depend" on the workspace.
       * So therefore we are using a workaround to learn about the current active workspace by reading localStorage value
       * TODO: fix this, see GitHub issue: https://github.com/sketch-hq/Cloud/issues/13134
       */}
      <PrivateRoute
        exact
        path={routes.UPDATES.template()}
        component={UpdatesGuard}
        skipErrorView
      />
    </Switch>
  )
}
